module.exports = fox => {
    'use strict';

    return {
        desktopBreakPoint: 1024,

        headerHeight: {
            mobile: 50,
            desktop: 76
        },

    }
};


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/utils/constants.es.js